
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vue-culqi-checkout.cjs.production.min.js')
} else {
  module.exports = require('./vue-culqi-checkout.cjs.development.js')
}
